import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { PageableTable, Button } from '../../components/common';
import { dictionary } from '../../lang';
import { useCastedParams } from '../../lib/hooks';
import { getTeamDispositions, selectTeamDispositions } from '../../redux';
import { urlTo } from '../../utils';
const columns = [
    {
        align: 'right',
        text: dictionary.ID,
        sortable: true,
        id: 'polygon_id',
    },
    {
        align: 'left',
        text: dictionary.TEAM_NAME,
        sortable: true,
        id: 'team_name',
    },
    {
        align: 'right',
        text: dictionary.NOT_KNOCKED,
        sortable: false,
        id: 'not_knocked',
    },
    {
        align: 'right',
        text: dictionary.FIRST_KNOCK,
        sortable: false,
        id: 'knocked_once',
    },
    {
        align: 'right',
        text: dictionary.SECOND_KNOCK,
        sortable: false,
        id: 'knocked_twice',
    },
    {
        align: 'right',
        text: dictionary.PROGRESS,
        sortable: false,
        id: 'completed',
    },
];
const TeamPolygonsTable = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { teamId } = useCastedParams(Number);
    const [sortParams, setSortParams] = useState({ name: 'polygon_id', order: 'asc' });
    const [pageSize, setPageSize] = useState(10);
    const [selectedPage, setSelectedPage] = useState(1);
    const { teamDispositions, total, isLoading } = useSelector(selectTeamDispositions);
    const teamDispositionsRows = useMemo(() => teamDispositions.map(({ id, teamName, notKnocked, knockedOnce, knockedTwice, completed, }) => ([
        id,
        teamName,
        notKnocked,
        knockedOnce,
        knockedTwice,
        completed,
    ])), [teamDispositions]);
    const updateTable = useCallback(() => {
        const params = {
            teamId,
            sort_by: sortParams.name,
            order: sortParams.order,
            page: selectedPage,
            limit: pageSize,
        };
        dispatch(getTeamDispositions.request(params));
    }, [
        dispatch,
        teamId,
        pageSize,
        selectedPage,
        sortParams,
    ]);
    useEffect(() => {
        updateTable();
    }, [updateTable]);
    return (_jsx(PageableTable, { leftControl: (_jsx(Button, { onClick: () => navigate(urlTo('teams/:teamId', { teamId })), children: dictionary.ADD_POLYGON })), loading: isLoading, columns: columns, rows: teamDispositionsRows, pageSize: pageSize, setPageSize: setPageSize, sortParams: sortParams, onSortChange: setSortParams, selectedPage: selectedPage, setSelectedPage: setSelectedPage, totalCount: total }));
};
export default TeamPolygonsTable;
